import { UserMenuService } from '@abp/ng.theme.shared';
import { inject, Injectable } from '@angular/core';
import { ZnVersion } from '../zn-version';
import { VersionService } from './proxy';

@Injectable({
  providedIn: 'root',
})
export class SystemVersion {
  private readonly userMenu = inject(UserMenuService);

  getAppVersion() {
    this.userMenu.addItems([
      {
        id: 'versionInfo',
        order: 107,
        component: ZnVersion,
        visible: () => true,
      },
    ]);
  }
}
